import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { MACHINES_MAIN_SCREEN, performanceComponentsConfig } from './config';
import { MachinesScreen } from '@v2/pages/machines/common/enums';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { useTrackMachinePerformanceOpened } from './hooks/useTrackMachinePerformanceOpened';

const PerformanceStack = createStackNavigator();

const PerformanceNavigation = ({ route }) => {
  useTrackMachinePerformanceOpened();

  return (
    <PerformanceStack.Navigator
      initialRouteName={MACHINES_MAIN_SCREEN + MachinesScreen.UTILIZATION}
      screenOptions={{ ...NAVIGATION_CONFIG, ...route.params }}
    >
      {performanceComponentsConfig.map(({ Component, name }) => (
        <PerformanceStack.Screen key={name} name={name} component={Component} initialParams={route.params} />
      ))}
    </PerformanceStack.Navigator>
  );
};

export { PerformanceNavigation };
